import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'

export type Tipologia = 'solleciti' | 'raccomandate'

interface GenerazioneSolleciti {
  daData: string
  aData: string
  dataSollecito: string
  tipologia: Tipologia
}

const generaSolleciti = async (servizioId: number, payload: GenerazioneSolleciti) => {
  const { data } = await axios.post(`/servizi/${servizioId}/genera-solleciti/`, payload)
  return data
}

const useGeneraSolleciti = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ servizioId, payload }: { servizioId: number; payload: GenerazioneSolleciti }) => {
      return generaSolleciti(servizioId, payload)
    },
    {
      onSuccess: (data: any, variables: any) => {
        // console.log('OK! - ', data)
        queryClient.invalidateQueries('avvisiPagamentoByMese')
        queryClient.invalidateQueries('gruppoSolleciti')
        queryClient.invalidateQueries('solleciti-queue')
      },
      onError: () => {},
    }
  )
}

export default useGeneraSolleciti
